import React from "react";
import Image from "next/image";

const HeroSection = () => {
  return (
    <div className="relative h-screen">
      {/* Background Image */}
      <Image
        src="/images/hero-about/hallway.svg"
        alt="Innovation Gallery"
        fill
        className="object-cover opacity-100"
        priority
      />

      {/* Overlay Content */}
      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="container mx-auto px-4">
          <div className="max-w-[600px] -ml-1 lg:-ml-3">
            <h1 className="font-inter font-bold text-3xl sm:text-4xl md:text-[48px] leading-tight md:leading-[62px] tracking-[0.5px] text-white mb-6">
              Leveraging Innovation for Collaboration and Impact
            </h1>
            <div className="max-w-[410px] mb-8 md:mb-12">
              <p className="font-medium text-base sm:text-lg md:text-[20px] leading-normal md:leading-[32px] tracking-[0.2px] text-white">
                Fun, interactive technology that builds an audience for
                meaningful engagements and real-world positive outcomes.
              </p>
            </div>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() =>
                  window.open(
                    "https://www.youtube.com/watch?v=PrqYohBV58o",
                    "_blank",
                  )
                }
                className="bg-accent hover:bg-accent-dark text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
                aria-label="Watch our Reel"
              >
                Watch our Reel
              </button>
              <button
                className="border-2 border-accent text-white hover:bg-accent hover:text-white font-semibold py-3 px-6 rounded-lg transition duration-300"
                aria-label="Get in Touch"
              >
                Get in Touch
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
